import React from 'react'
import PropTypes from 'prop-types'

class ChlorineTooltip extends React.Component {
  render() {
    const { active } = this.props

    if (active) {
      const { payload, label } = this.props

      if (payload && payload[0]) {
        var createdAt = payload[0].payload.createdAt
        var employee = payload[0].payload.employee
        var totalCl = payload[0].payload.total_chlorine_ppm
        var notes = payload[0].payload.notes

        return (
          <div className="well shadowDepth1">
            <p>
              <span className="grey-text">
                {createdAt}
                <br />
                {employee}
              </span>
              <br />
              <span className="small-text">
                {payload[0].fill &&
                  <span style={{color: payload[0].fill}}>
                    {payload[0].name + ": " + payload[0].value}
                    <br />
                  </span>
                }

                {(payload[1] && payload[1].fill) &&
                  <span style={{color: payload[1].fill}}>
                    {payload[1].name + ": " + payload[1].value}
                    <br />
                  </span>
                }

                <span style={{color: "#3C4789"}}>
                  {"Total Chlorine (PPM): " + totalCl}
                </span>

                {notes &&
                  <span className="grey-text">
                    <br />
                    {notes}
                  </span>
                }
              </span>
            </p>
          </div>
        );
      }
      else {

        return null;
      }
    }

    return null;
  }
}

ChlorineTooltip.propTypes = {
  type: PropTypes.string,
  payload: PropTypes.array,
  label: PropTypes.string
};

export default ChlorineTooltip
